<div class="dialog-title">
  Prospect Information
</div>

<div class="value-container">
  <div fxLayout="row wrap" matLine>

    <div class="full-col">
      <div class="xsDesc-f">
        Prospect Name
      </div>
      <div class="value-f">
        {{ data?.name }}
      </div>
    </div>

    <div class="full-col">
      <div class="xsDesc-f">
        Email
      </div>
      <div class="value-f download-link" [mailTo]="data?.email">
        <mat-icon class="indicator-12 color-primary">mail</mat-icon>
        {{ data?.email }}
      </div>
    </div>

    <div class="half-col">
      <div class="xsDesc-f">
        Phone Number
      </div>
      <div class="value-f">
        <img src="../../../assets/images/whatsapp.png" class="indicator-14 download-link" alt="" [whatsAppTo]="data?.phone"/>
         {{ data?.phone }}
      </div>
    </div>

  </div>
</div>
